import { Vec2 } from 'kaplay';
import { Tags } from '../constants/tags';

export function addSceneWall({
  sceneHeight,
  sceneWidth,
  side,
}: {
  sceneHeight: number;
  sceneWidth: number;
  side: 'left' | 'right' | 'top' | 'bottom';
}) {
  const WALL_THICKNESS = 2;
  add([
    pos(
      (() => {
        // Calculate wall position based on side using early returns
        if (side === 'left') return vec2(0, 0);
        if (side === 'right') return vec2(sceneWidth, 0);
        if (side === 'top') return vec2(0, 0);
        if (side === 'bottom') return vec2(0, sceneHeight);

        // Default fallback (shouldn't reach here with proper typing)
        throw new Error('unknown side given');
      })(),
    ),
    rect(
      ...((() => {
        if (side === 'left' || side === 'right') return [WALL_THICKNESS, sceneHeight];
        if (side === 'top' || side === 'bottom') return [sceneWidth, WALL_THICKNESS];
        throw new Error('unknown side given');
      })() as [number, number]),
    ),

    area(),
    body({
      isStatic: true,
    }),
    // make a very faint gray against white background
    color(235, 235, 235),

    Tags.WALL,
  ]);
}

export function addSceneWalls({
  sceneHeight,
  sceneWidth,
}: {
  sceneHeight: number;
  sceneWidth: number;
}) {
  addSceneWall({ sceneHeight, sceneWidth, side: 'left' });
  addSceneWall({ sceneHeight, sceneWidth, side: 'right' });
  addSceneWall({ sceneHeight, sceneWidth, side: 'top' });
  addSceneWall({ sceneHeight, sceneWidth, side: 'bottom' });
}

// TODO: use later
export function addWall({
  wallHeight,
  wallWidth,
  pos,
}: {
  wallHeight: number;
  wallWidth: number;
  pos: Vec2;
}) {
  return add([
    pos,
    rect(wallWidth, wallHeight),
    area(),
    body({
      isStatic: true,
    }),
    color(235, 235, 235), // very faint gray against white background
    Tags.WALL,
  ]);
}
